import React from 'react'
import Spinner from 'react-bootstrap/Spinner'

export default () => <Spinner animation="border" variant="primary" />
